import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects'
import { getInit, saveNew, overwrite, setMessageTemplateUpperLimitFlg } from 'reducers/mcbMessageDeadlineCompReducer'
import { openModal, openModalWithArg, openSnackbar } from 'reducers/messageReducer'
import { initRequest, newRequest, overwriteRequest } from 'apis/MCBHS080Api'
import { magiContants } from 'utils/contants'

export function* initSaga(action: ReturnType<typeof getInit>) {
  try {
    // 28KH #181571 START
    const initData = yield call(initRequest, action.payload)
    yield put(setMessageTemplateUpperLimitFlg(initData.messageTemplateUpperLimitFlg))
    // 28KH #181571 END
  } catch (error) {
    yield put(openModal(error.message))
  }
}
// 28KH #181571 START
export function* overwriteSaga(action: ReturnType<typeof overwrite>) {
  try {
    yield call(overwriteRequest, action.payload.apiData)
    yield put(openSnackbar(magiContants.MESSAGECODE_MCBHS080_006))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export function* saveNewSaga(action: ReturnType<typeof saveNew>) {
  try {
    yield call(newRequest, action.payload.apiData)
    yield put(openSnackbar(magiContants.MESSAGECODE_MCBHS080_011))
  } catch (error) {
    if ((error.message as string).includes(magiContants.MESSAGECODE_MCBHS080_010)) {
      const errmsg = (error.message as string).split(',')
      const [messageId, ...args] = errmsg
      yield put(openModalWithArg({ messageId, args }))
    } else {
      yield put(openModal(error.message))
    }
  }
}
// 28KH #181571 END

export default function* messageInputSaga() {
  // 28KH #181571 START
  yield all([
    takeEvery(getInit, initSaga),
    takeLeading(overwrite, overwriteSaga),
    takeLeading(saveNew, saveNewSaga)
  ])
  // 28KH #181571 END
}
